import React, {useState} from "react";
import FileInput, {FileDetails} from "@amzn/meridian/file-input";
import Modal from "@amzn/meridian/modal";
import Column from "@amzn/meridian/column";
import {MAX_CSV_SIZE_BYTES} from "../util/Constants";
import Alert from "@amzn/meridian/alert";
import Text from "@amzn/meridian/text";
import Button from "@amzn/meridian/button";
import Row from "@amzn/meridian/row";
import downloadTokens from "@amzn/meridian-tokens/base/icon/download-small";
import {FormattedMessage, injectIntl} from "react-intl";
import Icon from "@amzn/meridian/icon";
import {createDownloadableFile} from "../util/Util";

const UploadFileModal = (props) => {

    const {open, setOpen, parser, mac, updateConfig} = props;
    const [file, setFile] = useState(undefined)
    const [err, setErr] = useState("")
    const [output, setOutput] = useState([])

    // UI states
    const [complete, setComplete] = useState(false);
    const [percentage, setPercentage] = useState(0);

    // Setup file reader
    const fileReader = new FileReader();
    fileReader.onload = (event) => {
        processText(event.target.result, mac);
    };
    fileReader.onprogress = (event) => {
        setPercentage(event.total/event.loaded);
    };
    fileReader.onloadend = (event) => {
        setComplete(true);
    };

    const onCloseModal = () => {
        setOpen(false);
        resetState();
    }

    const resetState = () => {
        setFile(undefined);
        setErr("");
        setOutput([]);
        setComplete(false);
    }

    const onClickConfirm = () => {
        updateConfig(output);
        setOpen(false)
        resetState();
    }

    const setFileData = async (uploadedFile) => {
        const fileObj = uploadedFile[0];
        if (fileObj.size > MAX_CSV_SIZE_BYTES) {
            setErr("Error while uploading file: File size too large");
            return;
        }
        setFile(fileObj);
        setErr("");
        fileReader.readAsText(fileObj);
    }

    const processText = (text, mac) => {
        const output = parser.PARSE(text, mac);
        if (output.error) {
            setErr(output.error);
        } else {
            setOutput(output);
        }
    }

    const renderFileInput = () => {
        return (
            <Column>
                <Text>
                    <FormattedMessage id="upload.subtitle"
                          defaultMessage="Upload CSV file to overwrite the existing configuration."/>
                </Text>
                { !file ? renderPreUpload() : renderPostUpload() }
            </Column>
        )
    }

    const renderPreUpload = () => {
        return (
            <Column alignmentHorizontal="center">
                <FileInput onFileAttached={setFileData}
                           showDropZone={true}
                           accept=".csv"
                           type="single" />
                {err && <Alert type="error" size="medium"> {err} </Alert>}
                <Button type={"link"} onClick={() => createDownloadableFile("sample.csv", parser.SAMPLE)}>
                    <FormattedMessage id="upload.download_sample"
                          defaultMessage="Download sample CSV file"/> <Icon tokens={downloadTokens}/>
                </Button>
            </Column>
        )
    }
    const renderPostUpload = () => {
        return (
            <Column>
                <FileDetails error={file.error}
                             errorMessage={file.errorMessage}
                             file={file}
                             key={file.name}
                             cancelUploadButtonLabel={`Cancel, ${file.name}`}
                             onClickCancel={() => {
                                 fileReader.abort()
                                 resetState()
                             }}
                             removeFileButtonLabel={`Delete, ${file.name}`}
                             onClickRemoveFile={() => {
                                 resetState()
                             }}
                             uploadPercentage={percentage}
                             uploadComplete={complete}
                             uploadCompleteLabel={"Upload complete"}/>
                {err && <Alert type="error" size="medium"> {err} </Alert>}
                {output && !err &&
                <Column>
                    <Text color="secondary">
                        <FormattedMessage id="upload.file_length" values={{ length: output.length }} defaultMessage="The uploaded file contains {length} rows."/>
                    </Text>
                    <Text>
                        <FormattedMessage id="upload.confirm_overwrite" defaultMessage="Press confirm to overwrite the configuration."/>
                    </Text>
                    <Row>
                        <Button type="primary" onClick={onClickConfirm}><FormattedMessage id="modal.confirm"
                                                                        defaultMessage="Confirm"/>  </Button>
                        <Button type="secondary" onClick={onCloseModal}><FormattedMessage id="modal.cancel"
                                                                        defaultMessage="Cancel"/></Button>
                    </Row>
                </Column>
                }
            </Column>
        )
    }
    return (
        <Modal
            title={<FormattedMessage id="upload.title"
                 defaultMessage="Upload configuration through CSV"/> }
            open={open}
            onClose={onCloseModal}
            scrollContainer="viewport"
            closeLabel="Close"
            bodySpacingInset="medium">
            {renderFileInput()}
        </Modal>
    )
}

export default injectIntl(UploadFileModal);


// WEBPACK FOOTER //
// ./src/components/commonui/UploadFileModal.js